import { Injectable } from '@angular/core';
import { BffCommunicationService } from '../../core/services/_index';
import { AppConfigService } from '../../app-config.service';
import { Observable } from 'rxjs';
import { OctroiModele } from '../modeles/octroiModele';

@Injectable({
  providedIn: 'root'
})
export class OctroiApiService {
  constructor(
    private readonly _bffApiService: BffCommunicationService,
    private readonly _appConfigService: AppConfigService
  ) {}

  postOctroi(octroi: OctroiModele): Observable<any> {
    const idProjet = this._appConfigService.idProjet;
    return this._bffApiService.postJSONBFF(`/api/v1/projets/${idProjet}/octrois`, octroi);
  }

  postOctroiWithLocalisation(octroi: OctroiModele, idLocalisation: string): Observable<any> {
    const idProjet = this._appConfigService.idProjet;
    return this._bffApiService.postJSONBFF(`/api/v1/projets/${idProjet}/octrois/${idLocalisation}`, octroi);
  }

  getOctroi(): Observable<OctroiModele> {
    const idProjet = this._appConfigService.configData ? this._appConfigService.idProjet : null;
    return this._bffApiService.getJSONBFF(`/api/v1/projets/${idProjet}/octrois`) as Observable<OctroiModele>;
  }

  hasRepresentantDedie(): Observable<boolean> {
    return this._bffApiService.getJSONBFF('/api/v1/representants/possedeDedie') as Observable<boolean>;
  }
}
